/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Dialog, FilledButton, OutlinedButton } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = (props: { isOpen: boolean }) => {
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);
  const handleClick = () => setIsOpen((prev) => !prev);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <div className="n-flex n-justify-center">
        <FilledButton onClick={handleClick}>Open Dialog</FilledButton>
      </div>
      <Dialog
        htmlAttributes={{
          id: 'top-aligned-dialog',
        }}
        className="n-align-top n-mt-token-16"
        onClose={handleClose}
        isOpen={isOpen}
      >
        <Dialog.Header>Header</Dialog.Header>
        <Dialog.Content>This is where you put your content</Dialog.Content>
        <Dialog.Actions>
          <OutlinedButton onClick={handleClose} variant="neutral" size="medium">
            Secondary
          </OutlinedButton>
          <FilledButton onClick={handleClose} size="medium">
            Primary
          </FilledButton>
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default Component;
